'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["type"],
  _excluded2 = ["leftIcon", "rightIcon", "isActive", "iconSpacing", "command", "commandSpacing", "children"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var StyledMenuItem = react.forwardRef(function (props, ref) {
  var type = props.type,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var styles = react.useMenuStyles();

  /**
   * Given another component, use its type if present
   * Else, use no type to avoid invalid html, e.g. <a type="button" />
   * Else, fall back to "button"
   */
  var btnType = rest.as || type ? type !== null && type !== void 0 ? type : undefined : 'button';
  var buttonStyles = React.useMemo(function () {
    return _objectSpread({
      textDecoration: 'none',
      color: 'inherit',
      userSelect: 'none',
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      textAlign: 'start',
      flex: '0 0 auto',
      outline: 0
    }, styles.item);
  }, [styles.item]);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.button, _extends__default["default"]({
    ref: ref,
    type: btnType
  }, rest, {
    __css: buttonStyles
  }));
});
var MenuItem = react.forwardRef(function (props, ref) {
  var leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    isActive = props.isActive,
    _props$iconSpacing = props.iconSpacing,
    iconSpacing = _props$iconSpacing === void 0 ? '0.75rem' : _props$iconSpacing,
    command = props.command,
    _props$commandSpacing = props.commandSpacing,
    commandSpacing = _props$commandSpacing === void 0 ? '0.75rem' : _props$commandSpacing,
    children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded2);
  var menuitemProps = react.useMenuItem(rest, ref);
  var shouldWrap = leftIcon || rightIcon || command;
  var _children = shouldWrap ? /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      pointerEvents: 'none',
      flex: 1
    }
  }, children) : children;
  return /*#__PURE__*/React__default["default"].createElement(StyledMenuItem, _extends__default["default"]({}, menuitemProps, {
    "data-active": utils.dataAttr(isActive),
    className: utils.cx('chakra-menu__menuitem', menuitemProps.className)
  }), leftIcon && /*#__PURE__*/React__default["default"].createElement(react.MenuIcon, {
    fontSize: "0.8em",
    marginEnd: iconSpacing
  }, leftIcon), _children, command && /*#__PURE__*/React__default["default"].createElement(react.MenuCommand, {
    marginStart: commandSpacing
  }, command), rightIcon && /*#__PURE__*/React__default["default"].createElement(react.MenuIcon, {
    fontSize: "0.8em",
    marginStart: iconSpacing
  }, rightIcon));
});
MenuItem.displayName = 'MenuItem';
exports.MenuItem = MenuItem;
exports.StyledMenuItem = StyledMenuItem;